export enum DayType {
  NONE = 0,
  P = 1,
  W = 2,
  Ws = 3,
  Wn = 4,
  Wx = 5,
  U = 6,
  C = 7,
  Uo = 8,
  Nn = 9,
  Bw = 10,
  M = 11,
  Uoj = 12,
  D = 13,
  Ps = 14,
  Pw = 15,
  Xw = 16,
  Xb = 17,
  Uz = 18,
  U2 = 19,
  Cn = 20,
  Cb = 21,
  Z = 22,
  Zb = 23,
  Zs = 24,
  Zw = 25,
  Zn = 26,
  Od = 27,
  Or = 28,
  Np = 29,
  Nu = 30,
  Ui = 31,
  Un = 32,
  Ur = 33,
  Ux = 34,
  Us = 35,
  Um = 36,
  Uf = 37,
  Bp = 38,
  Rc = 39,
  Rw = 40,
  Rb = 41,
  Oo = 42,
  D1 = 43,
  D2 = 44,
  Sw = 45,
  Prz = 46,
  NoContract = 47,
  Wo = 48,
  WoC = 49,
  WoCn = 50,
  WoCb = 51,
  WoZ = 52,
  WoZb = 53,
  WoZs = 54,
  WoZw = 55,
  WoZn = 56,
  WoOd = 57,
  WoOr = 58,
  WoRc = 59,
  WoRw = 60,
  WoRb = 61,
  WoOo = 62,
  WoM = 63,
  WoUoj = 64,
  Xd = 65,
  Os = 66,
  WoOs = 67,
  MergedU = 68,
  MergedC = 69,
  S2 = 70,
  U5 = 71,
  Wu = 72,
}

export const LEAVE_DAY_TYPES: ReadonlySet<DayType> = new Set([
  DayType.U,
  DayType.Uo,
  DayType.Uoj,
  DayType.Uz,
  DayType.U2,
  DayType.Ui,
  DayType.Un,
  DayType.Ur,
  DayType.Ux,
  DayType.Us,
  DayType.Um,
  DayType.Uf,
  DayType.U5,
])
